import * as types from './../constants/actionTypes';

const initialState = { };

 const  historyReduser = (state = initialState, action) => {

    switch(action.type){

        case types.GET_HISTORY_SUCCESS:
            return {
                ...state,
                list: action.history
            };

        case types.GET_HISTORY_FAILED:
            return {
                ...state
            };

        case types.SEND_HISTORY_SUCCESSFUL:
            return {
                ...state,
                isFatchingHistory: false
            };

        case types.SEND_HISTORY_FAILED:
            return {
                ...state,
                isFatchingHistory: false
            };

        case types.SEND_HISTORY_PROGRESS:
            return {
                ...state,
                isFatchingHistory: true
        };

        default:
            return state;
    }
};

export default historyReduser;



// WEBPACK FOOTER //
// ./src/reducers/historyReducer.js